import { ResourceTypes } from 'parkchirp-shared/enums';
import { FC } from 'react';

import { SimpleModal } from '../modals';
import { AuditHistoryTable } from './auditHistoryTable';

type ModalProps = {
	title: string;
	resourceId: string;
	resourceType: ResourceTypes;
	timezone?: string;
	onClose: () => void;
};

export const AuditHistoryModal: FC<ModalProps> = ({ title, resourceId, resourceType, timezone, onClose }) => (
	<SimpleModal
		title={title}
		titleStyle={{
			textAlign: 'left',
		}}
		confirmText='Close'
		confirmButtonInTopRightOfHeader
		handleConfirm={onClose}
		content={<AuditHistoryTable resourceId={resourceId} resourceType={resourceType} timezone={timezone} />}
		contentStyle={{
			display: 'flex',
			flexDirection: 'column',
			margin: 'auto',
			minWidth: '350px',
		}}
	/>
);
